import { Base64Document } from 'profile-api';

let tenderCategories = [
    { code: 'CONSTRUCTION', description: 'Costruzione', url: '/wp-content/uploads/2015/12/Costruzione-300x300-1.png' },
    { code: 'RENOVATION', description: 'Ristrutturazione', url: '/wp-content/uploads/2020/02/Ristrutturazioni-300x300-1.png' },
    { code: 'SYSTEM', description: 'Impianti', url: '/wp-content/uploads/2015/06/Impianti-300x300-1.png' },
    { code: 'EXCAVATION', description: 'Scavi', url: '/wp-content/uploads/2015/12/Scavi-300x300-1.png' },
    { code: 'DEMOLITION', description: 'Demolizioni', url: '/wp-content/uploads/2015/06/Demolizioni-300x300-1.png' }
  ];

export function GetTenderCategories() {
    return tenderCategories;
}

export function GetTenderCategoryDescriprions() {
    return tenderCategories.map(tenderCategory => tenderCategory.code);
}

export function GetTenderCategoryByCode(tenderCategoryCode: string) {
    let cats = tenderCategories.filter(category => category.code === tenderCategoryCode);
    return cats[0];
}

export function GetTenderCategoryByDescription(tenderCategoryDescription: string) {
    let cats = tenderCategories.filter(category => category.description === tenderCategoryDescription);
    return cats[0];
}

export function GetTenderStatusDescription(tenderStatusCode: string) {
    let tenderStatuses = new Map();
    tenderStatuses.set('DRAFT','Bozza');
    tenderStatuses.set('ONGOING','In corso');
    tenderStatuses.set('DISCOUNT','Sconto');
    tenderStatuses.set('DEAL','Accordo');
    tenderStatuses.set('ACCEPTED','Accettata');
    tenderStatuses.set('REFUSED', 'Rifiutata');

    let stat = tenderStatuses.get(tenderStatusCode);

    return (stat === undefined || stat === null) ? tenderStatusCode : stat;
}

export function GetTenderAttachmentTypeDersciption(attachment: Base64Document) {
    let description: string;
    switch (attachment.documentType) {
        case 'IMAGE': 
            description = 'Immagine';
          break;
        case 'DRAWING': 
            description = 'Disegno';
          break;
        case 'OTHER': 
            description = 'Altro';
          break;
        default:
          break;
      }
    return description;
}
